import React from 'react';

import Logo from 'assets/images/register/logo-verde.svg';
import Avatar1 from 'assets/images/register/C1.png';
import Avatar2 from 'assets/images/register/C2.png';
import Avatar3 from 'assets/images/register/C3.png';
import Icon1 from 'assets/images/register/1.svg';
import Icon2 from 'assets/images/register/2.svg';
import Icon3 from 'assets/images/register/3.svg';
import Icon4 from 'assets/images/register/4.svg';
import Icon5 from 'assets/images/register/5.svg';
import Icon6 from 'assets/images/register/6.svg';
import Icon7 from 'assets/images/register/7.svg';
import Icon8 from 'assets/images/register/8.svg';
import Icon9 from 'assets/images/register/9.svg';
import Icon10 from 'assets/images/register/10.svg';
import Icon11 from 'assets/images/register/11.svg';
import Icon12 from 'assets/images/register/12.svg';
import Icon13 from 'assets/images/register/13.svg';
import Icon14 from 'assets/images/register/14.svg';
import Icon15 from 'assets/images/register/15.svg';

import IAImage from 'assets/images/register/IA.png';
import JuridicoImage from 'assets/images/register/JURIDICO.png';
import CursoImage from 'assets/images/register/CURSO.png';

import { RegisterCard } from '../register_card';

import { Container } from './styles';

const VIMEO_VIDEO_URL = 'https://player.vimeo.com/video/1060147613';

const benefits = [
  '15 dias gratuitos',
  'Consultoria jurídica em licitações',
  'Maior base de oportunidades do Brasil',
];

const features = [
  { id: 'boletins-licitacoes', label: 'Boletins de licitações', icon: Icon1 },
  { id: 'encontrar-licitacoes', label: 'Encontrar licitações', icon: Icon2 },
  { id: 'encontrar-acompanhamentos', label: 'Encontrar acompanhamentos', icon: Icon3 },
  { id: 'gerenciar-documentos', label: 'Gerenciar documentos', icon: Icon4 },
  { id: 'gerenciar-licitacoes', label: 'Gerenciar licitações', icon: Icon5 },
  { id: 'monitorar-chat', label: 'Monitorar chat', icon: Icon6 },
  { id: 'concorrentes', label: 'Concorrentes', icon: Icon7 },
  { id: 'analise-de-mercado', label: 'Análise de mercado', icon: Icon8 },
  { id: 'meu-historico', label: 'Meu histórico', icon: Icon9 },
  { id: 'contratos', label: 'Contratos', icon: Icon10 },
  { id: 'ata-registro-precos', label: 'Ata de registro de preços', icon: Icon11 },
  { id: 'licitacoes-estrategicas', label: 'Licitações estratégicas', icon: Icon12 },
  { id: 'juridico-facil', label: 'Jurídico fácil', icon: Icon13 },
  { id: 'artigos-juridicos', label: 'Artigos jurídicos', icon: Icon14 },
  { id: 'assessoria-cadastral', label: 'Assessoria cadastral', icon: Icon15 },
];

const aiFeatures = [
  { title: 'Dr. Licita', body: 'Crie petições e recursos em minutos.' },
  {
    title: 'Análise do Edital',
    body: 'Faça perguntas ou acesse um resumo completo do edital em minutos.',
  },
  {
    title: 'Consultor Jurídico',
    body: 'IA especializada para consultas jurídicas com segurança.',
  },
];

const legalFeatures = [
  {
    title: 'Especialistas em licitações',
    body: 'Nossa equipe de advogados possui ampla experiência em processos licitatórios, garantindo respostas precisas e eficazes.',
  },
  {
    title: 'Prevenção de erros',
    body: 'Orientação detalhada para evitar inconsistências e problemas documentais que possam comprometer sua participação.',
  },
  {
    title: 'Resolução de dúvidas',
    body: 'Tenha suporte jurídico em tempo hábil para lidar com impugnações, recursos e demais desafios legais.',
  },
  {
    title: 'Apoio em todas as etapas',
    body: 'Desde a análise de editais até a elaboração de recursos e contratos, nossa equipe está pronta para ajudar.',
  },
];

const footerLinks = [
  { label: 'Sobre', href: '#sobre' },
  { label: 'Planos', href: '#planos' },
  { label: 'Blog', href: '#blog' },
  { label: 'Termos de uso', href: '#termos' },
  { label: 'Privacidade', href: '#privacidade' },
  { label: 'Contato', href: '#contato' },
];

const RegisterLayout: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <Container className="min-vh-100 bg-white">
      <main>
        <div className="hero-section py-5 px-3 px-md-4">
          <div className="container-fluid" style={{ maxWidth: 1200 }}>
            <div className="mb-4">
              <a href="/" aria-label="conlicitação — início">
                <img src={Logo} alt="conlicitação" className="header-logo" />
              </a>
            </div>
            <div className="row align-items-center">
              <div className="col-lg-7 mb-5 mb-lg-0">
                <div className="d-flex flex-wrap mb-4" style={{ gap: 12 }}>
                  <div
                    className="badge-light-custom d-inline-flex align-items-center py-1 px-3"
                    style={{ gap: 10 }}
                  >
                    <span className="d-inline-flex">
                      <img className="avatar-img" src={Avatar1} alt="" />
                      <img className="avatar-img" src={Avatar2} alt="" />
                      <img className="avatar-img" src={Avatar3} alt="" />
                    </span>
                    <span style={{ lineHeight: 1 }}>mais de 80 mil usuários</span>
                  </div>
                  <div
                    className="badge-brand d-inline-flex align-items-center py-2 px-3"
                    style={{ gap: 10 }}
                  >
                    <span className="material-icons" aria-hidden="true">
                      auto_awesome
                    </span>
                    <span style={{ lineHeight: 1 }}>Pioneiro em IA para Licitante</span>
                  </div>
                </div>
                <h1 className="hero-title mb-3">
                  Venda mais
                  <br />
                  para o governo
                </h1>
                <p className="hero-subtitle mb-4">com a plataforma líder do mercado.</p>
                <p className="hero-lede mb-4">
                  Não perca tempo procurando editais. Entregamos as oportunidades certas para você
                  fechar mais contratos.
                </p>
                <ul className="list-unstyled d-flex flex-column" style={{ gap: 12 }}>
                  {benefits.map((text) => (
                    <li key={text} className="d-flex align-items-start" style={{ gap: 12 }}>
                      <span className="benefit-check d-inline-flex align-items-center justify-content-center mt-1">
                        <span className="material-icons" aria-hidden="true">
                          check
                        </span>
                      </span>
                      <span className="benefit-text">{text}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="col-lg-5">
                <div className="w-100">
                  <RegisterCard />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="feature-section py-5 px-3 px-md-4" id="plataforma">
          <div className="container-fluid" style={{ maxWidth: 1280 }}>
            <div className="text-center mb-5">
              <h2 className="feature-title mb-2">Criamos tecnologia de ponta para licitantes.</h2>
              <p className="feature-subtitle mb-0">
                Conheça as principais ferramentas da nossa plataforma
              </p>
            </div>

            <div className="feature-grid">
              {features.map((f) => (
                <div
                  key={f.id}
                  className="feature-card d-flex flex-column align-items-center justify-content-start text-center p-3"
                >
                  <img src={f.icon} alt="" className="feature-icon mb-3" />
                  <span className="feature-label">{f.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="ai-section py-5 px-3 px-md-4" id="ia">
          <div className="container-fluid" style={{ maxWidth: 1200 }}>
            <div className="row align-items-center">
              <div className="col-lg-6 text-center mb-4 mb-lg-0">
                <img src={IAImage} alt="" className="ai-media-img" />
              </div>
              <div className="col-lg-6">
                <span className="ai-kicker d-inline-block mb-3">Novidade</span>
                <h2 className="ai-title mb-3">
                  A <span className="ai-brand">Inteligência Artificial</span> chegou no ConLicitação
                </h2>
                <p className="ai-lede mb-4">
                  Tenha em mãos uma inteligência artificial treinada por nossos especialistas com
                  mais de 25 anos de experiência e conectada a maior e mais completa plataforma de
                  licitações do Brasil.
                </p>
                <ul className="list-unstyled d-flex flex-column" style={{ gap: 16 }}>
                  {aiFeatures.map((f) => (
                    <li key={f.title} className="d-flex align-items-start" style={{ gap: 16 }}>
                      <span className="check-ring d-inline-flex align-items-center justify-content-center mt-1">
                        <span className="material-icons" aria-hidden="true">
                          check
                        </span>
                      </span>
                      <div>
                        <p className="item-title mb-1">{f.title}</p>
                        <p className="item-body mb-0">{f.body}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="legal-section py-5 px-3 px-md-4" id="consultoria">
          <div className="container-fluid" style={{ maxWidth: 1200 }}>
            <div className="row align-items-center">
              <div className="col-lg-6 mb-4 mb-lg-0">
                <h2 className="legal-title mb-3">Consultoria Jurídica Especializada</h2>
                <p className="legal-lede mb-4">
                  Elimine suas dúvidas e evite erros. Com orientação precisa e ágil para tomar as
                  decisões corretas em momentos críticos, garantindo segurança e conformidade mesmo
                  sob pressão.
                </p>
                <ul className="list-unstyled d-flex flex-column mb-4" style={{ gap: 16 }}>
                  {legalFeatures.map((f) => (
                    <li key={f.title} className="d-flex align-items-start" style={{ gap: 16 }}>
                      <span className="check-ring d-inline-flex align-items-center justify-content-center mt-1">
                        <span className="material-icons" aria-hidden="true">
                          check
                        </span>
                      </span>
                      <div>
                        <p className="item-title mb-1">{f.title}</p>
                        <p className="item-body mb-0">{f.body}</p>
                      </div>
                    </li>
                  ))}
                </ul>
                <a href="#cadastro" className="btn cta-btn py-3 px-5">
                  Iniciar teste gratuito
                </a>
              </div>
              <div className="col-lg-6 text-center">
                <img src={JuridicoImage} alt="" className="legal-media-img" />
              </div>
            </div>
          </div>
        </div>
        <div className="social-section py-4 px-3 px-md-4">
          <div className="container-fluid" style={{ maxWidth: 1280 }}>
            <div className="social-card p-4 p-md-5">
              <div className="row align-items-center">
                <div className="col-lg-6 mb-4 mb-lg-0">
                  <h2 className="social-title mb-0">
                    <strong>+80 mil usuários</strong> economizam tempo e multiplicam seus resultados
                    com o <strong>ConLicitação!</strong>
                  </h2>
                </div>
                <div className="col-lg-6">
                  <div className="video-wrapper">
                    <iframe
                      src={VIMEO_VIDEO_URL}
                      className="video-iframe"
                      title="Depoimento de cliente — ConLicitação"
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                      allowFullScreen
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bonus-section py-5 px-3 px-md-4">
          <div className="container-fluid" style={{ maxWidth: 1200 }}>
            <div className="row align-items-center">
              <div className="col-lg-6 mb-4 mb-lg-0">
                <span className="bonus-badge d-inline-block py-2 px-3 mb-3">Bônus</span>
                <h2 className="bonus-title mb-3">Curso completo para iniciantes</h2>
                <p className="bonus-body mb-2">
                  Se você está dando os primeiros passos, o curso{' '}
                  <strong>&quot;Introdução ao Mundo das Licitações&quot;</strong>, incluso no plano,
                  é perfeito para você.
                </p>
                <p className="bonus-body mb-4">
                  Com uma linguagem prática e sem juridiquês, <strong>Pedro Lombardo</strong> ensina
                  como identificar oportunidades, superar barreiras e aproveitar o potencial de
                  vendas ao governo com segurança e eficiência.
                </p>
                <a href="#cadastro" className="btn cta-btn py-3 px-5">
                  Começar agora
                </a>
              </div>
              <div className="col-lg-6 text-center">
                <img src={CursoImage} alt="" className="bonus-img" />
              </div>
            </div>
          </div>
        </div>
      </main>
      <footer className="footer-section py-4 px-3 px-md-4">
        <div className="container-fluid" style={{ maxWidth: 1200 }}>
          <div className="d-flex flex-column align-items-center" style={{ gap: 20 }}>
            <a href="/" aria-label="conlicitação — início">
              <img src={Logo} alt="conlicitação" className="footer-logo" />
            </a>
            <nav className="d-flex flex-wrap justify-content-center" style={{ gap: 20 }}>
              {footerLinks.map((item) => (
                <a key={item.href} href={item.href} className="footer-link">
                  {item.label}
                </a>
              ))}
            </nav>
            <p className="footer-copy mb-0">© {year} ConLicitação · Todos os direitos reservados</p>
          </div>
        </div>
      </footer>
    </Container>
  );
};

export { RegisterLayout };
